module.exports = __webpack_public_path__ + "img/Mikae_on_klusteri_tummalle_taustalle_FI.cd63d86a.svg";